import { Image } from '@chakra-ui/react';
import { getContractAddress } from '@cronos-app/sdk';
import croSvg from '@public/tokens/cro.svg';

import type { TokenRegister } from '../types';
import { Token } from '../types';

export const getWcroToken: TokenRegister = (desiredNetwork) => {
  return {
    type: Token.wCRO,
    symbol: 'wCRO',
    address: getContractAddress(desiredNetwork, 'WCRO'),
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image src={croSvg.src} boxSize="24px" alt="wCRO" {...props} />
    ),
  };
};
